<template>
	<div>
		<!-- <v-container align="center" justify="center" class="pa-5 pb-0">
			<ImageUploadAndCrop v-show="showCropper" :image="cropperImage" />
		</v-container> -->

		<v-container align="center" justify="center" class="pa-5 pb-0">
			<v-dialog v-model="avatarModel" width="500">
				<v-card>
					<v-card-actions>
						<v-spacer></v-spacer>
						<v-btn color="primary" text @click="avatarModel = false"> Close </v-btn>
					</v-card-actions>
					<v-container align="center" justify="center">
						<v-img :src="avatarfilepreview"></v-img>
					</v-container>
				</v-card>
			</v-dialog>
		</v-container>

		<v-container align="center" justify="center" class="pa-5 pb-0">
			<v-list-item three-line>
				<v-list-item-content>
					<v-list-item-title class="mb-1 text-center text-wrap"><h1>About you</h1></v-list-item-title>
					<v-list-item-subtitle class="text-center text-wrap">Make your first impression 😊</v-list-item-subtitle>
				</v-list-item-content>
			</v-list-item>
		</v-container>

		<v-container>
			<v-form ref="locumAboutYouForm" class="pa-4 pb-1 pt-0">
				<v-card-text align="center" justify="center" class="justify-center text-left pb-0 pm-0">
					<v-row class="justify-center text-center pt-0 pb-0">
						<v-col>
							<v-avatar v-ripple class="justify-center text-center" :size="150" style="margin: auto" color="#F4F4F4" @click="avatarModel = true">
								<v-img :src="avatarfilepreview" alt="" :max-width="150" class="mx-auto"></v-img>
							</v-avatar>
						</v-col>
					</v-row>
					<v-row class="justify-center text-center" style="color: var(--v-primary-base)"
						><v-col style="color: primary; text-transform: none !important"
							><v-btn class="text-none text-wrap" text style="color: var(--v-primary-base)">
								<v-file-input
									ref="uploader"
									v-model="contentMedia"
									:class="{ 'body-1': $vuetify.breakpoint.mdAndUp, caption: $vuetify.breakpoint.smAndDown, 'custom-file-uploader': true }"
									accept=".png, .jpg, .jpeg, .gif, .pdf"
									placeholder="Upload a profile picture"
									show-size
									:truncate-length="15"
									:prepend-icon="''"
									:rules="imgRules"
									prepend-inner-icon="cloud_upload"
									style="color: var(--v-primary-base); border: none"
								/>
							</v-btn> </v-col
					></v-row>
					<v-row class="justify-center text-center">
						<v-col class="error--text">
							<v-card-text v-show="avatarError">Please upload a professional picture</v-card-text>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-textarea :rules="short_bioRules" outlined placeholder="Write your bio here." :value="short_bio" @change="change_bio"> </v-textarea>
						</v-col>
					</v-row>
					<v-row>
						<v-col>
							<v-select v-model="languages_selected" :rules="languageRules" :items="languages" multiple outlined chips placeholder="Select the languages you speak">
							</v-select>
						</v-col>
					</v-row>

					<v-row align="center" justify="center">
						<v-col align="center" justify="center" :cols="7">
							<DistinctYesNo :initial="hasIndemnity" :errors="indemnityYesNoErrors" @input="OnIndemnity">
								{{ getLabel('aboutSectionFileUploadTitle', 'Do you have Professional Indemnity Insurance?') }}
							</DistinctYesNo>
						</v-col>
					</v-row>

					<v-col :cols="12">
						<div v-show="hasIndemnity == 'yes'">
							<v-file-input
								:label="labelIndemnity"
								:persistent-hint="true"
								:class="{ 'custom-file-uploader': true }"
								:prepend-icon="''"
								prepend-inner-icon="cloud_upload"
								:dense="true"
								outlined
								chips
								show-size
								:error-messages="indemnityInputError"
								@change="handleIndemnityFile"
							></v-file-input>
							<span v-if="docExists('indemnityInsuranceFile')">Indemnity document already uploaded. Click above to upload a new document.</span>

							<!-- <v-card-text align="center" justify="center" class="justify-center text-center px-0">
								<v-menu v-model="insuranceExpiryMenu" offset-y :close-on-content-click="false" transition="scale-transition">
									<template #activator="{ on }">
										<v-text-field
											v-model="textDisplayExpiryDate"
											outlined
											class="pb-3"
											label="Select Professional Indemnity Insurance expiry date"
											append-icon="event"
											hint="Select or type the date (DD/MM/YYYY)"
											persistent-hint
											:rules="insuranceExpiryRules"
											v-on="on"
										></v-text-field>
									</template>
									<v-date-picker v-model="insuranceExpiry" :min="new Date().toISOString()" no-title @input="insuranceExpiryMenu = false"></v-date-picker>
								</v-menu>
							</v-card-text> -->
						</div>
					</v-col>
				</v-card-text>
			</v-form>
		</v-container>
	</div>
</template>

<script>
import axios from 'axios';
import moment from 'moment';

import { bus } from '@/main';
import store from '@/store';
import { compressImage, encodeImageBase64, resolveAssetImage } from '@/utils/util';

import DistinctYesNo from '@/components/custom/YesNo.vue';

// this is for the text input
// function formatTextDate() {
// 	let date = hasInsuranceInfo('indemnity_insurance_expiry');
// 	if (date) {
// 		const [month, day, year] = date.split('/');
// 		return `${day}/${month}/${year}`;
// 	}

// 	date = new Date().toISOString().substr(0, 10);
// 	const [year, month, day] = date.split('-');
// 	return `${day}/${month}/${year}`;
// }

//this fn converts the backend date into a usable date for the date picker
function formatPickerDate() {
	const date = hasInsuranceInfo('indemnity_insurance_expiry');
	if (!date) return null;

	const [month, day, year] = date.split('/');
	return `${year}-${month}-${day}`;
}

function hasInsuranceInfo(field) {
	return 'indemnity_insurance' in store.getters.user ? store.getters.user.indemnity_insurance[field] : null;
}

export default {
	components: {
		DistinctYesNo,
	},
	data: () => ({
		step: 'about-step',
		prefill_img: false,
		short_bio: '',
		short_bioRules: [v => !!v || 'Required', v => (!!v && v.length > 8) || 'Bio is too short.'],
		imgRules: [value => !value || value.size < 6291456 || 'File size should be less than 6 MB'],
		languages: [],
		languageRules: [v => !!v || 'Required', v => (!!v && v.length > 0) || 'Please select at least one language'],
		uploaded_image_base_64: false,
		avatarError: false,
		languages_selected: [],
		person_outline_img: require('@/assets/images/rocket_man_transparent.webp'),
		avatarModel: false,
		contentMedia: null,
		indemnityInputError: [],
		insuranceFile: false,
		indemnityYesNoErrors: false,
		insurance: hasInsuranceInfo('has_indemnity_insurance'),
		hasIndemnity: hasInsuranceInfo('has_indemnity_insurance') ? 'yes' : hasInsuranceInfo('has_indemnity_insurance') === false ? 'no' : 'none',
		insuranceExpiry: formatPickerDate(),
		insuranceExpiryMenu: false,
		textDisplayExpiryDate: '', //formatTextDate(),
	}),

	computed: {
		avatarfilepreview: function () {
			if (this.uploaded_image_base_64) return this.uploaded_image_base_64;
			return resolveAssetImage(this.tenant?.settings?.brandImages?.placeholders?.professional, require('@/assets/images/rocket_man_transparent.webp'));
		},

		labelIndemnity() {
			const { user } = store.getters;
			if ('documents' in user && user.documents.images.some(img => img == 'indemnityInsuranceFile')) {
				return this.getLabel('aboutSectionFileUploadInputLabel', 'Upload a new professional indemnity doc');
			} else {
				return this.getLabel('aboutSectionFileUploadInputLabel', 'Upload professional indemnity docs');
			}
		},
		insuranceExpiryRules() {
			if (this.insurance) {
				return [
					v => !!v || 'Required',
					v => (v && moment(v, 'DD/MM/YYYY', true).isValid()) || 'Date is not valid, the date format should be DD/MM/YYYY',
					v => (v && moment(v, 'DD/MM/YYYY', true).isSameOrAfter(moment(), 'day')) || 'Date can not be in the past',
				];
			}
			return [];
		},
		hasIndemnityIsValid() {
			return ['yes', 'no'].includes(this.hasIndemnity);
		},
	},

	watch: {
		async contentMedia(newValue) {
			if (newValue) this.avatarError = false;
			this.uploaded_image_base_64 = await this.getImageData(newValue);
		},

		insuranceExpiry() {
			this.textDisplayExpiryDate = ''; //this.formatDate(this.insuranceExpiry);
		},
	},

	async mounted() {
		this.languages = store.getters.configs.languages;

		this.validate();

		if (this.solo) {
			bus.$on('intent:submit-forms:' + this.name, data => {
				if (!this.avatarError && this.languages_selected.length > 0 && this.short_bio.length > 8 && this.hasIndemnityIsValid) {
					this.postToBackend(data);
				} else {
					this.validate();
				}
			});
		} else {
			bus.$on('intent:submit-forms', data => {
				if (!this.avatarError && this.languages_selected.length > 0 && this.short_bio.length > 8 && this.hasIndemnityIsValid) {
					this.postToBackend(data);
				} else {
					this.validate();
				}
			});
		}

		// called when the image is cropped successfully
		// bus.$on('image-cropped', blob => {
		// 	const reader = new FileReader();
		// 	reader.onload = event => {
		// 		this.cropperImage = null;
		// 		this.uploaded_image_base_64 = event.target.result;
		// 	};
		// 	reader.readAsDataURL(blob);
		// 	this.toggleCropper();
		// });

		// called when the image cropping is canceled
		// bus.$on('image-cropped-canceled', async () => {
		// 	this.toggleCropper();
		// 	this.cropperImage = null;
		// 	bus.$emit('update:spinning', true);
		// 	await this.getAvatar();
		// 	bus.$emit('update:spinning', false);
		// });

		this.languages_selected = store.getters.user?.languages || [];
		this.short_bio = 'short_bio' in store.getters.user ? store.getters.user.short_bio : '';

		try {
			bus.$emit('update:spinning', true);
			await this.getAvatar();
			bus.$emit('update:spinning', false);
		} catch (err) {
			console.error(err);
		}
	},
	beforeDestroy() {
		bus.$off('intent:submit-forms');
		// bus.$off('image-cropped');
		// bus.$off('image-cropped-canceled');
	},
	methods: {
		formatDate(date) {
			if (!date) return null;

			const [year, month, day] = date.split('-');
			return `${day}/${month}/${year}`;
		},
		async getImageData(file) {
			try {
				const result = await compressImage(file);
				return await encodeImageBase64(result);
			} catch (err) {
				return null;
			}
		},

		async handleImage(event) {
			this.avatarError = false;
			if (event != null) this.handleAvatarImage(event);
			else {
				bus.$emit('update:spinning', true);
				await this.getAvatar();
				bus.$emit('update:spinning', false);
			}
		},
		// toggleCropper() {
		// 	this.showCropper = !this.showCropper;
		// },
		async getAvatar() {
			const token = store.getters.jwtToken;
			try {
				const response = await axios.get(store.getters.getDOCUMENTS + '/images/avatar/' + store.getters.user.id, { headers: { Authorization: token } });
				if (response.status == 200) {
					this.uploaded_image_base_64 = 'data:image/png;base64,' + response.data.data;
				}
			} catch (err) {
				this.avatarError = true;
				console.error('Error msg: ', err);
			}
		},
		handleAvatarImage(fileObject) {
			const reader = new FileReader();
			reader.onload = event => {
				// this.cropperImage = event.target.result;
				this.uploaded_image_base_64 = event.target.result;
				// this.toggleCropper();
			};
			reader.readAsDataURL(fileObject);
		},
		OnIndemnity(option) {
			this.hasIndemnity = option;
			this.insurance = option == 'yes';
			if (this.hasIndemnityIsValid) {
				this.indemnityYesNoErrors = false;
			}
		},
		onClickAvatar() {
			this.$refs.uploader.$refs['input'].click();
		},

		validate() {
			this.indemnityYesNoErrors = false;

			if (!this.hasIndemnityIsValid) {
				this.indemnityYesNoErrors = 'Please select YES or NO';
				window.scrollTo(0, 0);
			}
			return this.$refs.locumAboutYouForm.validate() && !this.indemnityYesNoErrors;
		},
		reset() {
			this.avatarError = false;
			this.indemnityYesNoErrors = false;
			this.$refs.locumAboutYouForm.reset();
		},
		resetValidation() {
			this.avatarError = false;
			this.indemnityYesNoErrors = false;
			this.$refs.locumAboutYouForm.resetValidation();
		},
		change_bio(new_bio) {
			this.short_bio = new_bio;
		},
		checkStep(user) {
			const { short_bio, languages } = user;

			if (short_bio?.length >= 3 && languages?.length >= 1) {
				store.commit('SET_PROFILE_BUTTON_TO_POSITIVE', this.step);
				return true;
			} else {
				return false;
			}
		},
		async postToBackend() {
			let valid = this.validate();
			const token = store.getters.jwtToken;
			const { getDOCUMENTS, user, getAPI } = store.getters;

			if (valid && this.hasIndemnity == 'yes') {
				if (this.insuranceFile) {
					await axios.post(getDOCUMENTS + '/images/indemnityInsuranceFile/' + store.getters.user.id, this.insuranceFile, {
						headers: { Authorization: token },
					});
					if (!('documents' in user && user.documents.images.some(img => img == 'indemnityInsuranceFile'))) {
						let save = await axios.put(getAPI + '/professionals/documents/images', { doc: 'indemnityInsuranceFile' }, { headers: { Authorization: token } });
						await store.commit('SET_USER', save.data.data); //refresh the users state. await it completed.
					}
				} else {
					if (!this.docExists('indemnityInsuranceFile')) {
						this.indemnityInputError = ['Please provide an indemnity insurance file'];
						bus.$emit('update:spinning', false);
						window.scrollTo(0, 0);
						return 'no insurance file given';
					}
				}
			}

			if (valid && !this.avatarError && this.languages_selected.length > 0 && this.short_bio.length > 8) {
				bus.$emit('update:spinning', true);

				const { id, locations: userLocations = [], documents, address, willing_to_travel } = store.getters.user;
				let locations = userLocations;
				if (locations.length === 0) {
					locations.push(`${address.province},${address.region}`);
				}
				if (this.uploaded_image_base_64) {
					await axios.post(getDOCUMENTS + '/images/avatar/' + id, this.uploaded_image_base_64, {
						headers: { Authorization: token },
					});
				}
				if (!(documents && documents.images && documents.images.some(img => img == 'avatar'))) {
					let save = await axios.put(getAPI + '/professionals/documents/images', { doc: 'avatar' }, { headers: { Authorization: token } });
					await store.commit('SET_USER', save.data.data); //refresh the users state. await it completed.
				}

				let body = {
					short_bio: this.short_bio,
					willing_to_travel: willing_to_travel ? willing_to_travel : false,
					languages: this.languages_selected,
					locations,
					address,
					indemnity_insurance: this.insurance,
					indemnity_insurance_expiry: '',
				};

				const authHeader = { headers: { Authorization: token } };

				axios.put(getAPI + '/professionals/aboutme', body, { headers: { Authorization: token } }).then(async response => {
					bus.$emit('form-submitted', { form: this.name, status: response.status });
					if (response.status === 200) {
						await axios.put(`${getAPI}/calendar/professional/availability/update-all/${user.id}`, { languages: body.languages }, authHeader);
						store.commit('SET_USER', response.data.data); //refresh the users state.
						bus.$emit('update:spinning', false);
						bus.$emit('intent:next-step', 'about-step');
					}
				});
			}
		},
		getText() {
			return 'About Me';
		},
		handleIndemnityFile(fileObject) {
			this.indemnityInputError = [];
			const reader = new FileReader();

			reader.onload = e => {
				this.insuranceFile = e.target.result;
			};
			reader.readAsDataURL(fileObject);
		},
		docExists(docName) {
			return 'documents' in store.getters.user && store.getters.user.documents.images.some(img => img == docName);
		},
		parseDateToServerFormat(date) {
			if (!date) return null;

			const [day, month, year] = date.split('/');
			return `${month.padStart(2, '0')}/${day.padStart(2, '0')}/${year}`;
		},
	},
};
</script>
